import { useIntl }         from "react-intl";
import { useTranslations } from "../providers/translations-provider";
import { useMemo }         from "react";

export const useLocaleInfo = () => {
    const { currentLanguage: languageKey, setLanguage, translations } = useTranslations();
    const intl = useIntl();

    const { languageName, currentLanguage } = useMemo(() => {
        return {
            languageName: intl.formatMessage({ id: '__lang.__name' }),
            currentLanguage: intl.formatMessage({ id: `__lang.${ languageKey }` })
        }
    }, [languageKey]);

    const languages = useMemo(() => {
        return Object.keys(translations).map(language => {
            return {
                key: language,
                name: intl.formatMessage({ id: `__lang.${ language }` })
            }
        })
    }, [translations, currentLanguage]);

    return {
        languageKey,
        languageName,
        currentLanguage,
        setLanguage,
        languages
    }
}